import React from 'react';

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function Co2InformationView() {
	return (
		<div>
			<h2 id="ga4-co2-information">CO2 Information</h2>
			<div>
				<p>*These figures quoted have been recorded by the manufacturer during tests conducted in accodance with EU legislation. These figures are provided for comparison purposes only, users may achieve varying figures.</p>
				<p>CO2 and fuel economy figures may vary according to wheel fitment and optional extras fitted.</p>
				<p>Pricing and descriptions are correct at the time of release and are subject to change. All images are for illustrative purposes only. Actual details may vary from market to market and are subject to change without notice. Some vehicles are shown with optional equipment that may not be available in all markets.</p>
				<p>Please contact your local Morgan Retailer for availability and prices. Road Fund Licence and First Registration Fee, actual price will be set by the Retailer. Promotions are available for a limited time at participating Retailers only, please contact your local Morgan Retailer to confirm vehicle availability</p>
			</div>
		</div>
	);
}